import { getSymptomsBasic } from '../util/api';

export const FETCH_SYMPTOMS_BASIC_REQUEST = 'app/symptoms_basic/FETCH_SYMPTOMS_BASIC_REQUEST';
export const FETCH_SYMPTOMS_BASIC_SUCCESS = 'app/symptoms_basic/FETCH_SYMPTOMS_BASIC_SUCCESS';
export const FETCH_SYMPTOMS_BASIC_ERROR = 'app/symptoms_basic/FETCH_SYMPTOMS_BASIC_ERROR';

export const initialState = {
  symptoms: [],
  isFetching: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SYMPTOMS_BASIC_REQUEST:
      return { ...state, isFetching: true, fetchError: null };
    case FETCH_SYMPTOMS_BASIC_SUCCESS:
      return { ...state, isFetching: false, symptoms: payload, fetchError: null };
    case FETCH_SYMPTOMS_BASIC_ERROR:
      return { ...state, isFetching: false, fetchError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchSymptomsBasicRequest = () => ({ type: FETCH_SYMPTOMS_BASIC_REQUEST });
export const fetchSymptomsBasicSuccess = symptoms => ({
  type: FETCH_SYMPTOMS_BASIC_SUCCESS,
  payload: symptoms,
});
export const fetchSymptomsBasicError = error => ({
  type: FETCH_SYMPTOMS_BASIC_ERROR,
  payload: error,
});

// ================ Thunks ================ //

export const fetchSymptomsBasicData = state => {
  return {
    symptoms: state.symptomsBasic?.symptoms || [],
    isFetching: state.symptomsBasic?.isFetching || false,
    fetchError: state.symptomsBasic?.fetchError || null,
  };
};

export const fetchSymptomsBasic = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchSymptomsBasicRequest());
  try {
    const result = await getSymptomsBasic(params);
    dispatch(fetchSymptomsBasicSuccess(result.symptoms || []));
    return result;
  } catch (error) {
    console.error('Error fetching symptoms basic:', error);
    dispatch(fetchSymptomsBasicError(error.message || 'Failed to fetch symptoms basic'));
    throw error;
  }
};
